import React from 'react';
import { Button, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ArrowLeft, ArrowRight } from 'phosphor-react';
import { DIAS_SEMANA, MESES } from '~/constant';
import { FaFilter } from 'react-icons/fa';
import '../agenda.css';

export default function CabecalhoAgenda({
  dataSelecionada,
  changeDataSelecionada,
  atividadesFiltradas,
  toggleSidebar,
  filtros,
}) {
  const formatarData = () => {
    const data = new Date(dataSelecionada);
    const diaSemana = DIAS_SEMANA[data.getDay()];
    const dia = data.getDate();
    const mes = MESES[data.getMonth()];
    const ano = data.getFullYear();
    return `${diaSemana}, ${dia} de ${mes} ${ano}`;
  };

  const navegarMes = meses => {
    const novaData = new Date(dataSelecionada);
    novaData.setMonth(novaData.getMonth() + meses);
    changeDataSelecionada(novaData);
  };

  const temFiltrosAtivos = () => {
    return Object.keys(filtros || {}).some(
      key => key !== 'data_selecionada' && filtros[key] !== ''
    );
  };

  return (
    <Card style={{ border: 'none', boxShadow: 'none' }}>
      <div className="cabecalho-lista-atividades-agenda d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div className="d-flex flex-column">
          <div className="d-flex align-items-center" style={{ gap: '10px' }}>
            <span style={{ fontWeight: 700, fontSize: 17, color: '#222' }}>
              {formatarData()}
            </span>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Ir para hoje</Tooltip>}
            >
              <Button
                type="button"
                variant="outline-primary"
                size="sm"
                onClick={() => changeDataSelecionada(new Date())}
                style={{
                  borderColor: '#419AEF',
                  color: '#419AEF',
                  fontWeight: 600,
                  fontSize: 12,
                  padding: '2px 10px',
                }}
                aria-label="Ir para hoje"
              >
                Hoje
              </Button>
            </OverlayTrigger>
          </div>
          <span className="descricao-tarefas-dia">
            existe(m) {atividadesFiltradas.length} tarefa(s) para este dia.
          </span>
        </div>

        <div
          className="d-flex align-items-center justify-content-center mt-3 mt-md-0"
          style={{ gap: '8px' }}
        >
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Mês anterior</Tooltip>}
          >
            <button
              className="btn-sm-outline-crm d-flex align-items-center justify-content-center"
              onClick={() => navegarMes(-1)}
              aria-label="Mês anterior"
            >
              <ArrowLeft size={18} />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Próximo mês</Tooltip>}
          >
            <button
              className="btn-sm-outline-crm d-flex align-items-center justify-content-center"
              onClick={() => navegarMes(1)}
              aria-label="Próximo mês"
            >
              <ArrowRight size={18} />
            </button>
          </OverlayTrigger>

          <Button
            type="button"
            variant="outline-primary"
            size="md"
            onClick={toggleSidebar}
            className="d-flex align-items-center justify-content-center position-relative"
            style={{
              background: '#419AEF',
              borderColor: '#419AEF',
              minWidth: '85px',
              width: '85px',
              height: '38px',
              fontFamily: 'Open Sans, Arial, sans-serif',
            }}
            aria-label="Filtros"
          >
            <FaFilter
              color="#fff"
              size={16}
              style={{
                filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.3))',
              }}
            />

            {temFiltrosAtivos() && (
              <span
                style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '-4px',
                  width: '16px',
                  height: '16px',
                  backgroundColor: '#FF4444',
                  borderRadius: '50%',
                  border: '3px solid #fff',
                  boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
                }}
                aria-hidden="true"
              />
            )}
          </Button>
        </div>
      </div>
    </Card>
  );
}
